import { render, staticRenderFns } from "./Sur-B.vue?vue&type=template&id=b3d17600&scoped=true"
import script from "./Sur-B.vue?vue&type=script&lang=js"
export * from "./Sur-B.vue?vue&type=script&lang=js"
import style0 from "./Sur-B.vue?vue&type=style&index=0&id=b3d17600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d17600",
  null
  
)

export default component.exports